var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#47B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 3.375C5.895 3.375 3.375 5.895 3.375 9C3.375 9.07481 3.38231 9.14625 3.38625 9.22106H6.02606L7.30125 7.02731L9 9.46125L10.6948 7.02731L11.97 9.22106H14.6098C14.6137 9.14625 14.6211 9.07481 14.6211 9C14.625 5.895 12.105 3.375 9 3.375ZM12.8773 8.54269C12.6489 6.60375 10.9986 5.09625 9 5.09625C7.00144 5.09625 5.35106 6.60769 5.12269 8.54269H4.43981C4.66875 6.22856 6.62625 4.41731 9 4.41731C11.3737 4.41731 13.3273 6.22856 13.5602 8.54269H12.8773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6464 8.28735L8.99999 10.6499L7.35355 8.28735L6.41642 9.90004H3.45374C3.88517 12.5775 6.19874 14.625 8.99999 14.625C11.8012 14.625 14.1148 12.5775 14.5462 9.8961H11.5835L10.6464 8.28735ZM12.5702 10.575H13.2975C12.6523 12.3261 10.9727 13.5827 8.99999 13.5827C7.0273 13.5827 5.34767 12.3261 4.70249 10.575H5.4298C6.0373 11.9436 7.40642 12.9038 8.99999 12.9038C10.5935 12.9038 11.9627 11.9436 12.5702 10.575Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsr);
export default __webpack_public_path__ + "static/media/msr.753068e5f81bf11211679cc303d38792.svg";
export { ForwardRef as ReactComponent };